


























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BerkasRmService, { BerkasRm } from "@/services/BerkasRmService";
import DialogUploadBerkas from "@/components/pemeriksaan/berkasRm/DialogUploadBerkas.vue";
import BerkasTable from "@/components/pemeriksaan/berkasRm/BerkasTable.vue";

@Component({
  components: { DialogUploadBerkas, BerkasTable },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TabBerkasRm extends Vue {
  @Prop({ required: true }) rm!: string;
  @Prop({ default: "" }) register!: string;
  @Prop({ default: true }) isActive!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  items: BerkasRm[] = [];
  loading = false;

  innerTab = 0;

  uploadOpen = false;

  confirmDelete = false;
  toDelete: BerkasRm | null = null;
  deleting = false;

  get hasRegister(): boolean {
    return !!this.register;
  }

  get registerBerkas(): BerkasRm[] {
    return this.items.filter(b => b.scope === "register");
  }

  get pasienBerkas(): BerkasRm[] {
    return this.items.filter(b => b.scope === "pasien");
  }

  mounted() {
    this.fetch();
  }

  @Watch("rm")
  @Watch("register")
  onContextChange() {
    this.fetch();
  }

  @Watch("isActive")
  onActivated(val: boolean) {
    if (val) this.fetch();
  }

  async fetch() {
    if (!this.rm) return;
    this.loading = true;
    try {
      // Tanpa register aktif: ambil semua berkas pasien (level pasien + semua
      // kunjungan), supaya berkas yang diunggah ke register lampau tetap tampil.
      this.items = await BerkasRmService.list(
        this.rm,
        this.register ? { register_id: this.register } : {}
      );
    } catch (e) {
      // handled by ErrorAlert di service
    } finally {
      this.loading = false;
    }
  }

  openUpload() {
    this.uploadOpen = true;
  }

  onUploaded(created: BerkasRm) {
    this.items.unshift(created);
    // Pindah ke inner-tab yang relevan dengan hasil upload agar langsung terlihat.
    this.innerTab = created.scope === "register" ? 0 : 1;
  }

  onPreview(berkas: BerkasRm) {
    // Berkas dibuka lewat backend yang menempelkan watermark nama + waktu pembuka.
    BerkasRmService.openFile(berkas.id).catch(() => undefined);
  }

  onDelete(berkas: BerkasRm) {
    this.toDelete = berkas;
    this.confirmDelete = true;
  }

  async doDelete() {
    if (!this.toDelete) return;
    const target = this.toDelete;
    this.deleting = true;
    try {
      await BerkasRmService.remove(target.id);
      this.items = this.items.filter(b => b.id !== target.id);
      this.confirmDelete = false;
      this.toDelete = null;
    } catch (e) {
      // handled by ErrorAlert
    } finally {
      this.deleting = false;
    }
  }
}
